import {
  GatewayKind,
  GatewayStatus,
} from "src/components/shared-components/enum/enumGateway";
import { EnumStringConverter } from "src/components/shared-components/enum/enum-string-converter";

export class Gateway {
  public id: number = 0;
  public instanceGUID: string = "";
  public description: string = "";
  public kind: GatewayKind = GatewayKind.UNKNOWN;
  public ip: string = "";
  public port: number = 0;
  public pcName: string = "";
  public active: boolean = true;
  public useCrypto: boolean = false;
  public cryptoKey: string = "";
  public status: GatewayStatus = GatewayStatus.UNKNOW;
  public failedBusOperationCount = 0;

  constructor(gateway?: any) {
    // used for assign type to instance of object
    if (gateway) {
      Object.assign(this, gateway);
    }
  }

  public color(): string {
    let returnColor: string = "";
    if (this.active) {
      switch (this.status) {
        case GatewayStatus.CONNECTED:
          returnColor = "success";
          break;
        case GatewayStatus.NOT_CONNECTED:
          returnColor = "danger";
          break;
        case GatewayStatus.CONNECTING:
          returnColor = "warning";
          break;
        default:
          returnColor = "error";
          break;
      }
    } else {
      returnColor = "dark";
    }

    return returnColor;
  }

  /**
   * Check if generic gateway is "visible" to the user; this means that the Gateway is linked to a "front-end" function
   * (EX. controlling access-control features, or domotic functions) and not to a "back-end" one (EX. the handling of the Virtual Variables)
   *
   * @returns TRUE if the Gateway is "front-end"/Visible, FALSE otherwise.
   */
  public isVisible(): boolean {
    return (
      this.kind !== GatewayKind.VIRTUAL_VARIABLE &&
      this.kind !== GatewayKind.MQTT
    );
  }

  public gatewayKindName(): string {
    return EnumStringConverter.gatewayKindToStringEnum(this.kind);
  }
}
